// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"87673a0a","79":"f201eb08","389":"1a5a9233","398":"3747dc05","447":"afda2334","462":"0261b4f2","590":"984a3567","719":"10578059","745":"8b43d655","787":"c46215b6","855":"72144813","906":"fd914e99"}[chunkId] + ".chunk.js";
};